import Screen1 from '@/views/tvs/Screen1';
import Screen2 from '@/views/tvs/Screen2';
import Screen3 from '@/views/tvs/Screen3';
import Screen4 from '@/views/tvs/Screen4';
import Screen5 from '@/views/tvs/Screen5';
import Screen6 from '@/views/tvs/Screen6';

export const Routes = [
  {
    path: 'screen1/:studyId',
    name: 'Screen1',
    component: Screen1,
  },
  {
    path: 'screen2/:studyId',
    name: 'Screen2',
    component: Screen2,
  },
  {
    path: 'screen3/:studyId',
    name: 'Screen3',
    component: Screen3,
  },
  {
    path: 'screen4/:studyId',
    name: 'Screen4',
    component: Screen4,
  },
  {
    path: 'screen5/:studyId',
    name: 'Screen5',
    component: Screen5,
  },
  {
    path: 'screen6/:studyId',
    name: 'Screen6',
    component: Screen6,
  },
];

export const TvTestRoute = {
  path: '/tvtest',
  name: 'TvTest',
  component: {
    render(c) {
      return c('router-view');
    },
  },
  children: Routes,
};
